/**
 * Page: tracking/share
 */
import React, { ReactElement } from 'react';
import styled from 'styled-components';

/**  Types  */
export interface ITrackingSharePageProps {
    page: 'share';
    request_url: string;
    title: string;
    description: string;
    image_url: string;
    image_alt: string;
    destination_url: string;
    twitter_username: string | null;
    fb_client_id: string | null;
    company_name: string;
}

/**  Styled components  */
export const Root = styled.div({});

/**  Globals  */
const REDIRECT_DELAY_IN_SECONDS = 0;

/**
 * <head> contents
 * - <meta> tags for social media
 */
export function TrackingShareHead(props: ITrackingSharePageProps): ReactElement {
    const {
        destination_url,
        request_url,
        title,
        description,
        image_url,
        image_alt,
        company_name,
        twitter_username,
        fb_client_id,
    } = props;

    return (
        <>
            {/*  Redirection  */}
            <meta
                httpEquiv='refresh'
                content={`${REDIRECT_DELAY_IN_SECONDS};URL='${destination_url}'`}
            />

            {/*  OpenGraph (Facebook, LinkedIn)  */}
            <meta property='og:type' content='website' />
            <meta property='og:title' content={title} />
            <meta property='og:description' content={description} />
            <meta property='og:image' content={image_url} />
            <meta property='og:image:alt' content={image_alt} />
            <meta property='og:url' content={request_url} />
            <meta property='og:site_name' content={company_name} />

            {/*  Facebook specific  */}
            {fb_client_id ? <meta property='fb:app_id' content={fb_client_id} /> : null}

            {/*  Twitter */}
            <meta name='twitter:card' content='summary_large_image' />
            <meta name='twitter:title' content={title} />
            <meta name='twitter:description' content={description} />
            <meta name='twitter:image' content={image_url} />
            <meta name='twitter:image:alt' content={image_alt} />

            {twitter_username ? (
                <meta name='twitter:site' content={`@${twitter_username.replace('@', '')}`} />
            ) : null}
        </>
    );
}

/**
 * <body>: Handles redirect
 */
export function TrackingSharePage(props: ITrackingSharePageProps): ReactElement {
    const { destination_url } = props;

    return (
        <Root>
            {/*  */}
            {/*  */}
        </Root>
    );
}
